import { Component, OnInit, Input, AfterViewInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { SystemVersionHeader } from '../system-versions-header.model';
import { SystemVersion } from '../system-version.model';
import { SystemVersionRest } from '../system-versions.rest';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { MessageBoxComponent } from '../../../core/shared/message-box.component';
import { Subscription } from 'rxjs';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { MatExpansionPanel } from '@angular/material';

@Component({
  selector: 'smp-system-version-elements',
  templateUrl: './system-version-elements.component.html'
})
export class SystemVersionElementsComponent  implements OnInit, HasPermissions {
  permissions: Permissions;

  public viewEnable: boolean = true;
  public isDeleted: boolean;
  public successMessage: any;
  public showSuccessMessage: boolean;

  private headers = [
    { displayName: 'Nazwa', propertyName: 'name', propertyType: 'string' }
  ];

  @Input() data: SystemVersionHeader;
  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild(MatExpansionPanel) panel : MatExpansionPanel;
  @Output() rowEdited: EventEmitter<any> = new EventEmitter();
  
  constructor(
              private rest: SystemVersionRest,
              private permissionService: PermissionsService ) {
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType); 
  }

  ngOnInit(): void {
    this.setPermissions('SystemVersion');
    this.viewEnable = this.permissions.canShow;
  }

  public onRowEdit(row: SystemVersion) {
    let emittData = {isAdded: false, value: row };
    this.rowEdited.emit(emittData);
  }

  public onRowDelete(row: SystemVersion) {
    sweetAlert('Czy usunąć wersję systemu?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
        },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    })
    .then((value) => {
      switch (value) {
        case 'yes':
          this.rest.deleteSystemVersion(row.id).subscribe(() => {
            this.data.elements.splice(this.data.elements.indexOf(row), 1);
            sweetAlert('Pozycja systemu wersji została usunięta.');
            this.grid.refreshData();
          });

          break;
      }
    });
  }

  private getActionButtons() {
      return [];
  }
}
